$(document).on('click','.abreGastoModal', function(){
    var id = this.id.substr(6,25);
    $("#_method").val("PUT");
    $("#fichaGastoForm").attr('action',"gastos/"+id);
    $("#btnDeleteDocumento").css("display","block");
    $("#btnDeleteDocumento").attr('onclick',"document.getElementById('delete-"+id+"').submit()");
    $("#container-irpf-documento").show();
    $(".campo").val("");
    $.ajax({
        url: "gastos/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#proveedor_id").val(data['proveedor_id']);
            $("#fichaGastoLabel").html("Edición de gasto");
            //Serial
            $("#serial").val(data['serial']);
            //Fecha
            $("#fecha_emision").val(data['fecha_emision']);
            $("#fecha_pago").val(data['fecha_pago']);
            //Totales
            $("#subtotal").val(data['subtotal']);
            $("#irpf").val(data['irpf']);
            $("#iva").val(data['iva']);
            $("#ratio_iva").val(data['ratio_iva']);
            $("#total").val(data['total']);
            $("#deducible").prop('checked', data['deducible'] == 1 || data['deducible'] === true);
            if (data['banco_id']) {
                $("#gasto_banco_id").val(data['banco_id']);
            }
        }
    }); 
});



//FUNCIONES

const processOCR = (file, loadingElement) => {
    let formData = new FormData();
    formData.append('documento', file);
    formData.append('_token', $('meta[name="csrf-token"]').attr('content'));

    $(loadingElement).removeClass('d-none');
    
    $.ajax({
        url: "/gastos/ocr",
        type: "POST",
        data: formData,
        contentType: false,
        processData: false,
        success: function(data) {
            $(loadingElement).addClass('d-none');
            
            if (data.error) {
                alert("Error de IA: " + data.error);
                return;
            }

            // Preparar modal para nuevo registro (POST)
            // Si ya hay un proveedor_id, no lo borramos
            let currentProvId = $("#proveedor_id").val();
            
            $("#_method").val("POST");
            $("#fichaGastoForm").attr('action', "gastos");
            if (!currentProvId) $(".campo").val(""); // Solo limpiar si no venimos de un proveedor
            
            // Rellenar datos extraídos con validación
            if(data.serial) {
                $("#serial").val(data.serial);
            } else if(data.fecha) {
                $("#serial").val(data.fecha.replace(/-/g, '') + "-AI"); 
            }
            
            if(data.fecha) {
                $("#fecha_emision").val(data.fecha);
            }
            
            let base = parseFloat(data.base_imponible) || 0;
            let total = parseFloat(data.total) || 0;
            
            $("#subtotal").val(base.toFixed(2));
            $("#total").val(total.toFixed(2));
            
            // Calcular IVA
            let iva = total - base;
            $("#iva").val(iva.toFixed(2));
            $("#ratio_iva").val(data.ratio_iva || 1);
            $("#irpf").val(0);
            $("#deducible").prop('checked', true);
            $("#fecha_pago").val("");
            
            // Abrir modal si no está abierto
            $("#fichaGastoLabel").html("Validar Gasto Extraído por IA");
            var modalEl = document.getElementById('fichaGasto');
            var isVisible = modalEl.classList.contains('show');
            
            if (!isVisible) {
                var myModal = new bootstrap.Modal(modalEl);
                myModal.show();
            }
            
            alert("IA: Datos extraídos con éxito. " + (currentProvId ? "" : "Por favor, selecciona el proveedor correspondiente."));
        },
        error: function(xhr, status, error) {
            $(loadingElement).addClass('d-none');
            console.error("Detalle del error OCR:", xhr.responseText);
            alert("Error al conectar con el servicio de IA.\nCódigo: " + xhr.status + "\nError: " + error);
        }
    });
};

$(document).on('change', '#ocr-upload', function() {
    let file = this.files[0];
    if (file) processOCR(file, "#ocr-loading");
});

$(document).on('click', '#modal-ocr-btn', function() {
    $("#modal-ocr-file").click();
});

$(document).on('change', '#modal-ocr-file', function() {
    let file = this.files[0];
    if (file) processOCR(file, "#modal-ocr-loading");
});
